import { Action } from '@ngrx/store';

import { Message, MessageType } from './../../message';

export const ADD_MESSAGE = '[Notifications] Add Message';
export class AddMessage implements Action {
  readonly type = ADD_MESSAGE;
  constructor(public payload?: Message) {}
}

export const REMOVE_MESSAGE = '[Notifications] Remove Message';
export class RemoveMessage implements Action {
  readonly type = REMOVE_MESSAGE;
  constructor(public payload?: Message) {}
}

export const CLEAR_MESSAGES = '[Notifications] Clear Messages';
export class ClearMessages implements Action {
  readonly type = CLEAR_MESSAGES;
  constructor(public payload?: MessageType) {}
}

export type Actions = AddMessage | RemoveMessage | ClearMessages;
